import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import Player from '../player';

export class CarruselPrincipal {
    constructor() {
        this.$carruselPrincipal = $('.main-carrusel');
        this.players = {};
        this.$players = {};
        this.init();
    }

    init() {
        let incializado = false;

        new Swiper(".main-carrusel", {
            modules: [Navigation, Pagination, Autoplay],
            speed: 600,
            slidesPerView: "auto",
            centeredSlides: true,
            centerInsufficientSlides: true,
            spaceBetween: 24,
            loop: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".main-carrusel .der",
                prevEl: ".main-carrusel .izq",
            },
            pagination: {
                el: ".main-carrusel__paginacion",
            },
            on: {
                init: (swiper) => {
                    this.crearPlayers();
                    incializado = true;
                    const $primerVideo = $(swiper.slides[swiper.activeIndex]).find(".video");
                    if ($primerVideo.length > 0) {
                        swiper.autoplay.stop()
                        const id = $primerVideo.attr("id");
                        this.players[id].playEnListo();
                        this.$players[id].on("video-finalizado", function () {
                            $(this).off("video-finalizado");
                            swiper.slideNext(600)
                            swiper.autoplay.start();
                        })
                    }
                },
                "activeIndexChange": (swiper) => {
                    if (incializado === false) {
                        return;
                    }
                    this.pararVideos();
                    this.quitarListnersVideos();
                    const $video = $(swiper.slides[swiper.activeIndex]).find(".video");
                    if ($video.length > 0) {
                        const id = $video.attr("id");
                        swiper.autoplay.stop();
                        this.players[id].playEnListo();
                        this.$players[id].on("video-finalizado", function () {
                            $(this).off("video-finalizado");
                            swiper.slideNext(600)
                            swiper.autoplay.start();
                        });
                    }
                }
            },
        });
    }

    crearPlayers() {
        const $videos = this.$carruselPrincipal.find(".ctr-video");
        let self = this;
        $videos.each(function( index ){
            const player = new Player($(this), false, false);
            const id = player.getId();
            self.players[player.getId()] = player;
            self.$players[id] = $(this);
        });
    }

    quitarListnersVideos() {
        $.each(this.$players, function(index, $player) {
            $player.off("video-finalizado");
        });
    }

    pararVideos() {
        $.each(this.players, function(index, player) {
            player.parar();
        });
    }
}